import { ssrTrack } from '@/lib/actions/analytics/ssr-track';
import {
    flexAtom,
    openFlexCustomerModalAtom,
    openTargetOffsetModalAtom,
} from '@/ui/atoms/form-atoms';
import { useAtom } from 'jotai';
import styles from './ContinueButton.module.css';
export const ContinueButton: React.FC = () => {
    const [flex, setFlex] = useAtom(flexAtom);
    const [_0, setOpenTargetOffsetModal] = useAtom(openTargetOffsetModalAtom);
    const [_1, setOpenFlexCustomerModal] = useAtom(openFlexCustomerModalAtom);

    return (
        <div
            className={styles.but}
            onClick={() => {
                ssrTrack('clickContinue', { flex });

                if (flex) {
                    setOpenFlexCustomerModal((v) => !v);
                } else {
                    setOpenTargetOffsetModal((v) => !v);
                }
            }}
        >
            Continue
        </div>
    );
};
